import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

export default function Button({children, fullwidth, ...rest}) {
  return (
    rest?.to ? (
      <LinkStyle {...rest} fullwidth={fullwidth}>{children}</LinkStyle> 
    ) : (
      <ButtonStyle {...rest} fullwidth={fullwidth}>{children}</ButtonStyle>
    )
  )
}

const fullWidthStyle = css`
  ${props =>
    props.fullwidth &&
    css`
      width: 100%;
      justify-content: center;
      & + & {
        margin-left: 0;
      }
    `}
`;

const ButtonStyle = styled.button`
  ${fullWidthStyle}
`;

const LinkStyle = styled(Link)`
  ${fullWidthStyle}
`;